import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { Seo } from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { Reveal } from "../components/Reveal";
import { LEGAL } from "../data/legal";

const KEY_BY_PATH = { "/impressum": "impressum", "/datenschutz": "datenschutz", "/agb": "agb" };

export default function Legal() {
  const { pathname } = useLocation();
  const { lang, pick } = useLang();
  const key = KEY_BY_PATH[pathname];
  const data = key && LEGAL[key];
  if (!data) return <Navigate to="/" replace />;

  const title = pick(data.title);
  return (
    <>
      <Seo
        title={`${title} | PlastoNord GmbH`}
        description={`${title} der PlastoNord GmbH – ${data.intro ? pick(data.intro) : ""}`}
        path={data.path}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: title, path: data.path }]}
      />
      <section className="border-b border-[#e4e9f0] bg-[#f6f8fb] grain">
        <div className="pn-container py-14 md:py-20">
          <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: title, path: data.path }]} />
          <Reveal>
            <p className="overline">{lang === "de" ? "Rechtliches" : "Legal"}</p>
            <h1 className="mt-4 font-head text-4xl font-light tracking-tight text-[#16181D] md:text-5xl">{title}</h1>
            {data.intro && <p className="mt-5 max-w-2xl text-[#4a4d52]">{pick(data.intro)}</p>}
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <article className="pn-container max-w-3xl">
          {data.sections.map((s, i) => (
            <Reveal key={i} delay={Math.min(i * 0.03, 0.2)}>
              <div className="mb-9" data-testid={`legal-section-${i}`}>
                <h2 className="font-head text-xl font-semibold text-[#16181D]">{pick(s.h)}</h2>
                {s.p && s.p.map((para, j) => (
                  <p key={j} className="mt-2 leading-relaxed text-[#4a4d52]">{para}</p>
                ))}
                {s.list && (
                  <ol className="mt-3 list-decimal space-y-1.5 pl-5 text-[#4a4d52]">
                    {s.list.map((li, j) => <li key={j} className="leading-relaxed">{li}</li>)}
                  </ol>
                )}
                {s.after && s.after.map((para, j) => (
                  <p key={`a${j}`} className="mt-3 leading-relaxed text-[#4a4d52]">{para}</p>
                ))}
              </div>
            </Reveal>
          ))}
          <p className="mt-10 text-sm text-[#4a4d52]">{lang === "de" ? "Stand" : "Last updated"}: {data.updated}</p>
        </article>
      </section>
    </>
  );
}
